import React, { useState } from "react";
import {
  ChevronUp,
  ChevronDown,
  MoreVertical,
  Edit2,
  Trash2,
  Type,
  Hash,
  Calendar,
  Clock,
  ToggleLeft,
  List,
} from "lucide-react";

export default function ColumnHeader({
  column,
  sortConfig,
  onSort,
  onEdit,
  onDelete,
  width,
  onResize,
}) {
  const [showMenu, setShowMenu] = useState(false);

  const getDataTypeIcon = (dataType) => {
    switch (dataType) {
      case "text":
        return <Type className="w-3 h-3" />;
      case "number":
      case "double":
        return <Hash className="w-3 h-3" />;
      case "date":
        return <Calendar className="w-3 h-3" />;
      case "datetime":
        return <Clock className="w-3 h-3" />;
      case "boolean":
        return <ToggleLeft className="w-3 h-3" />;
      case "select":
        return <List className="w-3 h-3" />;
      default:
        return null;
    }
  };

  const isSorted = sortConfig.key === column.column_key;
  const isSystemColumn = ["id", "created_at", "updated_at"].includes(
    column.column_key
  );

  return (
    <th
      className="relative px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider select-none"
      style={{ width }}
    >
      <div className="flex items-center gap-2">
        <button
          onClick={() => onSort(column.column_key)}
          className="flex items-center gap-1 hover:text-gray-700 transition-colors"
        >
          {getDataTypeIcon(column.data_type)}
          <span>{column.display_name}</span>
          {column.is_required && <span className="text-red-500">*</span>}

          <div className="ml-1">
            {isSorted ? (
              sortConfig.direction === "asc" ? (
                <ChevronUp className="w-3 h-3" />
              ) : (
                <ChevronDown className="w-3 h-3" />
              )
            ) : (
              <div className="w-3 h-3" />
            )}
          </div>
        </button>

        {(onEdit || onDelete) && !isSystemColumn && (
          <div className="relative ml-auto">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(!showMenu);
              }}
              className="p-1 hover:bg-gray-100 rounded transition-colors"
            >
              <MoreVertical className="w-3 h-3" />
            </button>

            {showMenu && (
              <>
                <div
                  className="fixed inset-0 z-10"
                  onClick={() => setShowMenu(false)}
                />
                <div className="absolute right-0 mt-1 w-36 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-20">
                  {onEdit && (
                    <button
                      onClick={() => {
                        onEdit();
                        setShowMenu(false);
                      }}
                      className="w-full flex items-center gap-2 px-3 py-1.5 hover:bg-gray-50 text-sm text-gray-700"
                    >
                      <Edit2 className="w-3 h-3" />
                      컬럼 수정
                    </button>
                  )}
                  {onDelete && (
                    <button
                      onClick={() => {
                        onDelete();
                        setShowMenu(false);
                      }}
                      className="w-full flex items-center gap-2 px-3 py-1.5 hover:bg-red-50 text-sm text-red-600"
                    >
                      <Trash2 className="w-3 h-3" />
                      컬럼 삭제
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {/* Resize Handle */}
      <div
        className="absolute right-0 top-0 bottom-0 w-1 cursor-col-resize hover:bg-blue-500 transition-colors"
        onMouseDown={(e) => onResize(e.clientX)}
      />
    </th>
  );
}
